import { Injectable } from '@angular/core';
import { BaseApiService } from '../../../shared/base-service/base-api.service';

@Injectable()
export class PowerBIService extends BaseApiService {

    /**
      * Gets the Power BI Embed Config
      */
    public getEmbedConfig(powerBIEmbedMapName) {
        return this.get(`Foundation/Reports/PowerBI/EmbedConfig/${powerBIEmbedMapName}`);
    }

    /**
     * Gets user's Reports Permissions for validating access to reports
     */
    public getUserReportPermissions(powerBIEmbedMapName) {
        return this.get(`Foundation/Reports/PowerBI/UserReportPermissions/${powerBIEmbedMapName}`);
    }
}
